export default __webpack_public_path__ + "static/media/how_to_4.e7df09de.jpg";